<template>
    <div
        :class="`card col-${size} bg-${showBackground ? currentConfiguration.backgroundClass : ''} ${
            showBackground ? currentConfiguration.borderClass : ''
        } ${type} form-section material-card ${fullHeight ? 'full-height' : ''}`"
    >
        <div class="card-body p-0">
            <section
                :class="`p-2 ${currentConfiguration.titleClass} d-flex justify-content-between align-items-center`"
                v-if="title"
            >
                <div class="d-flex align-items-center">
                    <h6 class="mb-0 d-flex align-items-center">
                        <b :class="`me-2 ${titleClass}`">{{ title }}</b>
                        <a
                            v-if="popoverContent && popoverContent.length > 0"
                            tabindex="0"
                            href="javascript:void(0);"
                            role="button"
                            v-custom-popover="{
                                content: popoverContent,
                                placement: 'right'
                            }"
                        >
                            <i class="fas fa-info-circle text-primary"></i>
                        </a>
                    </h6>
                    <template v-if="showProductPill">
                        <ProductPill class="application-name" :product-id="getApplicationId(applicationId)" />
                    </template>
                </div>
                <div v-if="isFindAMatch" class="d-flex">
                    <img src="../../../../img/Axxess_Intelligence_logo_2.svg" alt="" />
                    <button class="ai-premium-btn ms-2 mt-1">Premium</button>
                </div>
                <template v-if="cancel !== null">
                    <button type="button" class="close-button me-2" @click="cancel()">
                        <i class="fas fa-xs fa-times"></i>
                    </button>
                </template>
            </section>
            <div class="ai-line" v-if="isFindAMatch"></div>
            <slot name="title"></slot>
            <slot name="content"></slot>
            <slot name="content_2"></slot>
        </div>
    </div>
</template>

<style src="./FormSection.scss"></style>

<script lang="ts" src="./FormSection"></script>
